module.exports = __webpack_public_path__ + "static/media/Week4.c577a824.pdf";